import * as ActionTypes from '../../constants/actionTypes';

export const FEATURES_CONTENT_TYPES = {
  default: "default",
  costAndShippingType: "costAndShippingType",
  toolSettingsType: "toolSettingsType",
}

const initialState = {
  catId: "",
  groupName: "",
  featuresList: [],
  featuresListAllFeatures: [],
  featuresListReceived: false,
  searchTerm: "",
  featuresSetupTopPanelState: "",
  pendingFeatures: {},
  featuresSetupTogglePopupOpened: false,
  featuresSetupTogglePopupFeature: null,
  featuresSetupDeletePopupOpened: false,
  featuresContentType: FEATURES_CONTENT_TYPES.default,
  editPopupFeatureId: null,
  sharedFeatureNameToggleValue: false,
  showShippingSetupPopup: false,
  showMarkUpDownPopup: false,
};

export default function (state = initialState, action) {
  switch (action.type) {

    case ActionTypes.FEATURES_SETUP_LOAD_FEATURES:
      return {
        ...state,
        featuresList: action.payload.featuresList || [],
        featuresListAllFeatures: action.payload.featuresList ? [...action.payload.featuresList] : [],
        featuresListReceived: true
      };
    case ActionTypes.FEATURES_SETUP_CLEAR:
      return Object.assign({}, initialState, {
        pendingFeatures: {},
        searchTerm: "",
      });
    case ActionTypes.FEATURES_SETUP_SET_FEATURES_LOADING:
    case ActionTypes.FEATURES_SETUP_UPDATE_FEATURES:
    case ActionTypes.FEATURES_SETUP_UPDATE_FEATURE:
    case ActionTypes.FEATURES_SETUP_SET_SEARCH_TERM:
    case ActionTypes.FEATURES_SETUP_SET_FEATURE_GROUP:
    case ActionTypes.FEATURES_SETUP_TOGGLE_POPUP_OPENED:
    case ActionTypes.FEATURES_SETUP_DELETE_POPUP_OPENED:
    case ActionTypes.FEATURES_SETUP_SHARED_FEATURE_NAME_TOGGLE:
    case ActionTypes.FEATURES_SETUP_SET_CONTENT_TYPE:
    case ActionTypes.FEATURES_SETUP_SET_PENDING_FEATURES:
    case ActionTypes.FEATURES_SETUP_SET_EDIT_POPUP_FEATURE_ID:
    case ActionTypes.FEATURES_SETUP_SHOW_SHIPPING_SETUP_POPUP:
    case ActionTypes.FEATURES_SETUP_SHOW_MARK_UP_DOWN_POPUP:
      return Object.assign({}, state, {...action.payload});
  }

  return state;
}
